import {
  useCentraSelectionResponse,
  CentraCheckoutShippingCentraOption,
} from "@made-people/grease-centra";
import { ShippingMethods } from "@made-people/blueprint-checkout";
import { useTranslate } from "@made-people/grease-translations";
import { MMShippingCountrySelector } from "../blueprint/checkout/MMShippingCountrySelector";

export const MMCentraShippingMethodsRenderer = () => {
  const selectionResponse = useCentraSelectionResponse();
  const translate = useTranslate();

  if (!selectionResponse) {
    return null;
  }

  if (selectionResponse.shippingMethods.length === 0) {
    return null;
  }

  const sortedShippingMethods = [...selectionResponse.shippingMethods].sort(
    (a, b) => a.priceAsNumber - b.priceAsNumber,
  );

  return (
    <ShippingMethods
      heading={{
        heading: translate("Checkout_Choose_Shipping_Method"),
      }}
    >
      <MMShippingCountrySelector />
      {sortedShippingMethods.map((method) => (
        <CentraCheckoutShippingCentraOption
          method={method}
          key={method.shippingMethod}
        />
      ))}
    </ShippingMethods>
  );
};
